/* Simple localStorage wishlist: heart toggles on product cards + header drawer. */
(function () {
  var KEY = 'pah_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync();
    render();
  }
  function has(handle) {
    return read().some(function (x) { return x.handle === handle; });
  }
  function toggle(item) {
    var l = read();
    var idx = -1;
    for (var k = 0; k < l.length; k++) { if (l[k].handle === item.handle) { idx = k; break; } }
    if (idx === -1) { l.push(item); } else { l.splice(idx, 1); }
    write(l);
    return idx === -1;
  }
  function remove(handle) {
    write(read().filter(function (x) { return x.handle !== handle; }));
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  function addToCart(btn) {
    var id = btn.getAttribute('data-variant-id');
    var handle = btn.getAttribute('data-handle');
    if (!id) return;
    var item = null, list = read();
    for (var i = 0; i < list.length; i++) { if (list[i].handle === handle) { item = list[i]; break; } }
    btn.disabled = true;
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (typeof window.refreshCart === 'function') { window.refreshCart(); }
        remove(handle); // drop it from the wishlist after adding
        showToast({
          message: 'Added to cart',
          image: item && item.image,
          icon: 'shopping-cart',
          actionText: 'View cart',
          actionHref: root() + 'cart'
        });
      })
      .catch(function () {
        btn.disabled = false;
        showToast({ message: 'Could not add to cart. Please try again.', icon: 'alert-circle' });
      });
  }

  function sync() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? 'inline-flex' : 'none';
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = has(btn.getAttribute('data-wishlist-handle'));
      btn.classList.toggle('is-wished', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function showToast(opts) {
    opts = opts || {};
    var wrap = document.getElementById('pah-toast-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.id = 'pah-toast-wrap';
      document.body.appendChild(wrap);
    }
    var media = opts.image
      ? '<img src="' + esc(opts.image) + '" alt="" class="pah-toast__img">'
      : '<span class="pah-toast__icon"><i data-lucide="' + esc(opts.icon || 'check') + '"></i></span>';
    var action = opts.actionText
      ? '<a href="' + esc(opts.actionHref || '#') + '" class="pah-toast__action">' + esc(opts.actionText) + '</a>'
      : '';
    var t = document.createElement('div');
    t.className = 'pah-toast';
    t.innerHTML =
      '<div class="pah-toast__inner">' +
        media +
        '<div class="pah-toast__body">' +
          '<p class="pah-toast__msg">' + esc(opts.message || '') + '</p>' + action +
        '</div>' +
        '<button type="button" class="pah-toast__close" aria-label="Close"><i data-lucide="x"></i></button>' +
      '</div>';
    wrap.appendChild(t);
    if (window.lucide) lucide.createIcons();
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () { dismissToast(t); }, 3200);
  }

  function dismissToast(t) {
    if (!t || t.dataset.dismissing) return;
    t.dataset.dismissing = '1';
    t.classList.remove('is-in');
    t.classList.add('is-out');
    setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 350);
  }

  function addToCartHtml(p) {
    var btnCls = 'mt-2 inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary text-on-primary text-xs font-label-bold rounded-lg hover:opacity-90 transition-opacity cursor-pointer uppercase tracking-wider disabled:opacity-60';
    var icon = '<i data-lucide="shopping-cart" class="w-3.5 h-3.5 block"></i>';
    if (!p.variantId) {
      // No stored variant (legacy item) -> open quick-add modal to choose
      return '<button type="button" class="' + btnCls + '"' +
        ' data-quick-add-trigger' +
        ' data-product-handle="' + esc(p.handle) + '"' +
        ' data-product-title="' + esc(p.title) + '"' +
        ' data-product-tags="' + esc(p.tags || '') + '">' + icon + '<span>Add to cart</span></button>';
    }
    // Add the first (default) variant straight to cart; user adjusts in cart later.
    return '<button type="button" class="' + btnCls + '"' +
      ' data-wishlist-add' +
      ' data-variant-id="' + esc(p.variantId) + '"' +
      ' data-handle="' + esc(p.handle) + '">' + icon + '<span>Add to cart</span></button>';
  }

  function render() {
    var list = document.getElementById('wishlist-drawer-items');
    if (!list) return;
    var items = read();
    var empty = document.getElementById('wishlist-drawer-empty');
    if (!items.length) {
      list.innerHTML = '';
      if (empty) empty.classList.remove('hidden');
      return;
    }
    if (empty) empty.classList.add('hidden');
    list.innerHTML = items.map(function (p) {
      return '' +
        '<div class="flex gap-3 py-3 border-b border-outline-variant/20">' +
          '<a href="' + esc(p.url) + '" class="w-16 h-16 rounded-lg overflow-hidden bg-surface-container shrink-0 border border-outline-variant/30 block">' +
            (p.image ? '<img src="' + esc(p.image) + '" alt="" class="w-full h-full object-cover">' : '') +
          '</a>' +
          '<div class="min-w-0 flex-1">' +
            '<a href="' + esc(p.url) + '" class="block text-sm font-label-bold text-on-surface truncate no-underline hover:text-primary">' + esc(p.title) + '</a>' +
            (p.price ? '<p class="text-sm text-primary font-bold mt-1">' + esc(p.price) + '</p>' : '') +
            addToCartHtml(p) +
          '</div>' +
          '<button type="button" data-wishlist-remove="' + esc(p.handle) + '" class="shrink-0 self-start p-1.5 text-on-surface-variant hover:text-primary rounded-full cursor-pointer" aria-label="Remove">' +
            '<i data-lucide="x" class="w-4 h-4 block"></i>' +
          '</button>' +
        '</div>';
    }).join('');
    if (window.lucide) lucide.createIcons();
  }

  function openDrawer() {
    var p = document.getElementById('wishlist-drawer');
    var b = document.getElementById('wishlist-drawer-backdrop');
    render();
    if (p) p.classList.add('is-open');
    if (b) { b.classList.remove('opacity-0', 'pointer-events-none'); b.classList.add('opacity-100'); }
    document.body.classList.add('overflow-hidden');
  }
  function closeDrawer() {
    var p = document.getElementById('wishlist-drawer');
    var b = document.getElementById('wishlist-drawer-backdrop');
    if (p) p.classList.remove('is-open');
    if (b) { b.classList.add('opacity-0', 'pointer-events-none'); b.classList.remove('opacity-100'); }
    document.body.classList.remove('overflow-hidden');
  }

  document.addEventListener('click', function (e) {
    var tc = e.target.closest('.pah-toast__close');
    if (tc) { e.preventDefault(); dismissToast(tc.closest('.pah-toast')); return; }
    var t = e.target.closest('[data-wishlist-toggle]');
    if (t) {
      e.preventDefault(); e.stopPropagation();
      var item = {
        handle: t.getAttribute('data-wishlist-handle'),
        title: t.getAttribute('data-wishlist-title'),
        url: t.getAttribute('data-wishlist-url'),
        image: t.getAttribute('data-wishlist-image'),
        price: t.getAttribute('data-wishlist-price'),
        variantId: t.getAttribute('data-wishlist-variant'),
        variantCount: t.getAttribute('data-wishlist-variant-count'),
        tags: t.getAttribute('data-wishlist-tags')
      };
      var added = toggle(item);
      showToast(added
        ? { message: 'Added to wishlist', image: item.image, icon: 'heart' }
        : { message: 'Removed from wishlist', icon: 'heart' });
      return;
    }
    var add = e.target.closest('[data-wishlist-add]');
    if (add) { e.preventDefault(); e.stopPropagation(); addToCart(add); return; }
    var rm = e.target.closest('[data-wishlist-remove]');
    if (rm) {
      e.preventDefault(); e.stopPropagation();
      remove(rm.getAttribute('data-wishlist-remove'));
      showToast({ message: 'Removed from wishlist', icon: 'heart' });
      return;
    }
    if (e.target.closest('[data-wishlist-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-wishlist-close]') || e.target.id === 'wishlist-drawer-backdrop') { closeDrawer(); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  // When a product is added to cart (from the wishlist or anywhere), close the wishlist drawer
  document.addEventListener('cart:item-added', function () { closeDrawer(); });
  document.addEventListener('DOMContentLoaded', function () { sync(); render(); });
  sync();
})();
